import React from "react";
import { priceFormat } from "@/utils/common";
import { processDescText } from "../../utils";
import "./index.less";
import { GoodsItem } from "@/pages/charge-vip/types";
import { getPromotionLabel } from "@/pages/charge-vip/utils";

export interface SingleRowGoodsItemWithBuyProps {
  goodItem: GoodsItem;
  index: number;
  isDiscount: boolean;
  showCreditPrice: boolean;
}

export const SingleRowGoodsItemWithBuy: React.FC<
  SingleRowGoodsItemWithBuyProps
> = ({ goodItem, index, isDiscount, showCreditPrice }) => {
  const promotionLabel = getPromotionLabel(goodItem);
  const showCouponPrice = !!promotionLabel;
  return (
    <>
      <div
        className={`single-row-good-item-with-buy`}
        key={`good-${goodItem?.skuId}-${index}`}
      >
        <div className="good-price-wrap">
          <div className="good-price">
            <div className="big-heavy-text">¥{goodItem?.worth}</div>
          </div>
        </div>

        <div className="good-info-wrap">
          <div className="good-fill-wrap">
            <div className="good-title">{goodItem?.name || "--"}</div>
            <div className="good-extra">
              {processDescText(goodItem?.desc).map(
                (line: string, idx: number, array) => (
                  <React.Fragment key={idx}>
                    {line}
                    {idx < array.length - 1 && <br />}
                  </React.Fragment>
                ),
              )}
            </div>
          </div>

          <div className="good-buy-wrap">
            {showCouponPrice && !goodItem?.soldOut && promotionLabel && (
              <div className="good-redpack">{promotionLabel.text}</div>
            )}
            {goodItem?.soldOut ? (
              <div className="good-buy-btn sold-out-btn">
                <span className="good-buy-btn-text" style={{ color: '#fff', WebkitTextFillColor: '#fff', fontWeight: 'normal' }}>已售罄</span>
              </div>
            ) : (
              <div
                className={`good-buy-btn ${showCouponPrice ? "showCouponPrice" : ""}`}
              >
                <span className="good-price-content">
                  <span className="big-heavy-text-unit">¥</span>
                  <span className="big-heavy-text">
                    {priceFormat(
                      isDiscount
                        ? goodItem?.discountBuyPrice
                        : goodItem?.salePrice,
                    )}
                  </span>
                </span>
                {isDiscount && (
                  <span className="good-line-price">
                    ¥{priceFormat(goodItem?.salePrice)}
                  </span>
                )}
              </div>
            )}
            <div className="good-points">
              {!goodItem?.soldOut && goodItem?.maxUseCreditAmount &&
                showCreditPrice &&
                `积分价：${goodItem?.maxUseCreditAmount}`}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
